import { useSelector } from 'react-redux';
import React, { useState,useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ProductListCard from './ProductListCard';
import { loadSearchProductList } from "../../redux/actions";
import { AnalyticsDataStore } from '../../hooks/analytics-data';

const SearchProductListPage = () => {
    const location        = useLocation();
    const searchParams    = new URLSearchParams(location.search);
    const search_keyword  = searchParams.get("search_keyword") ? searchParams.get("search_keyword") : '';
    const company_user_id = searchParams.get("company_user_id") ? searchParams.get("company_user_id") :  '';
    const company_id      = searchParams.get("company_id") ? searchParams.get("company_id") : '';

    const [grid, setGrid]         = useState(false);
    const [active, setActive]     = useState(false);
    const [products, setProducts] = useState([]); 
    const [loading, setLoading]   = useState(false); 
    const [error, setError]       = useState(null);     
    const region                         = useSelector(state => state.region.region);// Get the current region from the state
    const [totalItems, setTotalItems]    = useState(0);  //total no of item
    const [currentPage, setCurrentPage ] = useState(1); //current page
    const [totalPages , setTotalPages ]  = useState(0); //total no of page
    const [startItem, setStartItem ]     = useState(0); // starting number
    const [endItem , setEndItem ]        = useState(0); // ending number
    const [sorting, setSorting]          = useState('price_asc');  //sorting order

    const sidebarController = () => {
        setActive(!active);
    }  
      
    const fetchSearchProducts = useCallback(async () => {
        try {
            setLoading(true);
            const response = await loadSearchProductList(search_keyword, company_id, company_user_id, region, currentPage, sorting);
            let products   = [];

            if(response?.page?.data?.products) {
                products = response?.page?.data?.products;

                let totalItem    = response?.page?.data?.total;
                let itemsPerPage = Math.max(products?.length || 0, 9);
                let totalPage    = Math.ceil(totalItem / itemsPerPage);

                setProducts(products); 
                setTotalItems(totalItem);
                setTotalPages(totalPage);

                const analyticsStore = new AnalyticsDataStore();
                analyticsStore.rootStore = {};
                analyticsStore.view_item(products);   

                let startItems = 0;
                if(totalItem !== 0) {
                    startItems = (currentPage - 1) * itemsPerPage + 1;
                } 
                const endItems = Math.min(currentPage * itemsPerPage, totalItem);

                setStartItem(startItems);
                setEndItem(endItems);
            }                           
            
            setLoading(false);

        } catch (error) {
            setError(error?.message); 
            setLoading(false);
        } finally {
            setLoading(false); 
        }
    }, [company_id, company_user_id, currentPage, search_keyword, region, sorting]);   

    // Fetch products data from API
    useEffect(() => {   
        fetchSearchProducts();         
    }, [fetchSearchProducts]);


    const handlePageChange = async (page) => {
        if (page >= 1 && page <= totalPages) {            
            setCurrentPage(page);
            await fetchSearchProducts();
        }
    };

    return (
        <section className="shop py-80">
            <div className={`side-overlay ${active && "show"}`}></div>
            <div className="container container-lg">
                <div className="row">
                    {/* Content Start */}
                    <div className="col-lg-12">
                        {/* Top Start */}
                        <div className="flex-between gap-16 flex-wrap mb-40 ">
                            <span className="text-gray-900">Showing {startItem}–{endItem} of {totalItems} result</span>
                            <div className="position-relative flex-align gap-16 flex-wrap">
                                <div className="list-grid-btns flex-align gap-16">
                                    <button onClick={() => setGrid(true)}
                                        type="button"
                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${grid === true && "border-main-600 text-white bg-main-600"}`}
                                    >
                                        <i className="ph-bold ph-list-dashes" />
                                    </button>
                                    <button onClick={() => setGrid(false)}
                                        type="button"
                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${grid === false && "border-main-600 text-white bg-main-600"}`}
                                    >
                                        <i className="ph ph-squares-four" />
                                    </button>
                                </div>
                                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                    <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                        Sort by:{" "}
                                    </label>
                                    <select defaultValue={1}
                                        className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                        id="sorting"
                                        value={sorting}
                                        onChange={(e) => setSorting(e.target.value)}  // Handle change
                                    >
                                        <option value='price_asc'>Price Asc</option>
                                        <option value='price_desc'>Price Desc</option>
                                    </select>
                                </div>
                                <button onClick={sidebarController}
                                    type="button"
                                    className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                >
                                    <i className="ph-bold ph-funnel" />
                                </button>
                            </div>
                        </div>
                        {/* Top End */}

                             
                        {products?.length > 0 ? (    
                            <div className={`list-grid-wrapper ${grid ? "list-view" : ""}`}>                  
                                {products.map((product, index) => ( // Fixed by adding {}
                                    <ProductListCard key={index} product={product} />
                                ))}
                            </div>
                        ) : (
                            <h6 className='text-center p-30'>No products available</h6> 
                        )}   
                        
                        
                        {/* Pagination Start */}
                        {totalItems > 0 && (
                            <ul className="pagination flex-center flex-wrap gap-16">
                                {/* Previous Button */}
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <Link
                                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                        to="#"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                    >
                                        <i className="ph-bold ph-arrow-left" />
                                    </Link>
                                </li>

                            {/* Page Numbers */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                                        <Link
                                            className="page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                            to="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handlePageChange(page);
                                            }}
                                        >
                                            {page.toString().padStart(2, "0")}
                                        </Link>
                                    </li>
                                ))}

                                {/* Next Button */}
                                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                    <Link
                                        className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                        to="#"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                    >
                                        <i className="ph-bold ph-arrow-right" />
                                    </Link>
                                </li>
                            </ul>
                        )}
                        {/* Pagination End */}
                    </div>
                    {/* Content End */}
                </div>
            </div>
        </section>
    )
}

export default SearchProductListPage;